module.exports = __webpack_public_path__ + "img/swiper2.aa1c8d7e.jpg";